import card1 from '~/static/images/request/address/card1.svg';
import card2 from '~/static/images/request/address/card2.svg';
import card3 from '~/static/images/request/address/card3.svg';

export type addressCardProps = {
  image: string,
  description: string,
}

export const addressCard: addressCardProps[] = [
  {
    image: card1,
    description: 'Городской Wi-Fi. Дом.ру построил более 9000 Wi-Fi точек в регионах России.',
  },
  {
    image: card2,
    description: 'Индивидуальные условия. Подключайте только те услуги, которые нужны.',
  },
  {
    image: card3,
    description: 'Круглосуточный мониторинг сети. Помехи устраняются до обнаружения их клиентом.',
  },
];
